import { render, staticRenderFns } from "./TableauResultats.vue?vue&type=template&id=ffa2456e&scoped=true&"
import script from "./TableauResultats.vue?vue&type=script&lang=js&"
export * from "./TableauResultats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa2456e",
  null
  
)

export default component.exports